<template>
  <lila-default-template :loading-signal-r="loadingSignalR">
    <template #mainContent>
      <div
        class="container patient-list"
        :class="loadingContent ? 'loading large' : ''"
      >
        <patient-area-tabs
          v-if="canManage"
          v-model="activeArea"
        />

        <h1
          v-show="activeArea === 'atendimento'"
          class="title"
        >
          Pacientes
        </h1>

        <lila-message :alert-data="alert" />

        <div
          v-show="!loadingContent && activeArea === 'atendimento'"
          class="columns"
        >
          <div class="column is-narrow patient-sidebar">
            <div
              ref="conversationList"
              class="conversation-list custom-scroll"
            >
              <div class="conversation-content">
                <div class="conversation-list-header patient-list-header">
                  <div
                    :class="
                      !$AccessControl.cannot(
                        $Session.get($userSessionName).profile,
                        'add_patient'
                      )
                        ? 'box-input-search'
                        : ''
                    "
                  >
                    <lila-button
                      v-if="
                        !$AccessControl.cannot(
                          $Session.get($userSessionName).profile,
                          'add_patient'
                        )
                      "
                      type="route"
                      title="Adicionar"
                      class="submit-buttons"
                      path="step1PatientInformation"
                    />
                    <form @submit.prevent="filterBy('byNameOrRegisterNumber')">
                      <lila-input
                        v-model="search.byNameOrRegisterNumber"
                        type="inputSearch"
                        class="with-shadow"
                        placeholder="Pesquisar"
                        title="Insira o nome ou número de matrícula para pesquisar"
                        :readonly="loadingInfinityScroll"
                        :btn-clear-search="search.activateClearSearchBtn"
                        @custom-clear-search-input-event="
                          clearFilterBy('byNameOrRegisterNumber')
                        "
                      />
                    </form>
                  </div>

                  <div class="menu">
                    <ul>
                      <li
                        :class="filterByVisible ? 'active' : ''"
                        @click="openOptions('filterBy')"
                      >
                        Filtrar por
                      </li>
                    </ul>

                    <button
                      v-show="
                        filterByVisible &&
                          (search.activeCid || search.activeEstadio)
                      "
                      class="clear-filter"
                      :disabled="loadingInfinityScroll"
                      @click="clearFilterBy('byCidEstadio')"
                    >
                      <lila-svgIcon
                        :src="require('@assets/icons/delete.svg')"
                      />
                      Limpar Filtro
                    </button>
                  </div>

                  <div
                    v-show="orderByVisible"
                    class="order-by"
                  >
                    <lila-radio
                      label=""
                      name="orderBy"
                      :options="orderByList"
                    />
                  </div>

                  <div
                    v-show="filterByVisible"
                    class="filter-by"
                  >
                    <lila-input
                      v-model="search.cidCode"
                      placeholder="Selecionar CID"
                      class="filter-by-cid"
                      :readonly="true"
                      :disabled="loadingInfinityScroll"
                      @custom-click-event="openCidModal"
                    />

                    <lila-select
                      v-model="search.byEstadio"
                      placeholder="Selecionar Estadio"
                      :options="estadioList"
                      :readonly="loadingInfinityScroll"
                      @custom-change-event="filterBy('byEstadio')"
                    />
                  </div>
                </div>

                <lila-patient-card
                  :data-list="data.patientList"
                  :selected-patient="data.selectedPatient || {}"
                  router-path="myPatientChat"
                  @custom-click-event="selectPatient"
                />

                <div ref="scrollSentinel" />

                <div
                  v-show="loadingInfinityScroll"
                  class="loading small"
                />
                <div
                  v-show="pagination.lastPage"
                  class="last-page has-text-centered"
                >
                  - - -
                </div>
              </div>
            </div>
          </div>

          <div class="column patient-column">
            <div
              v-if="pageName == 'myPatients' || !data.selectedPatient"
              class="wait-patient has-text-centered"
            >
              <figure class="image">
                <img :src="require('@assets/images/doctor.png')">
              </figure>
              <p>
                Clique nos cards ao lado para interagir e para mais informações
              </p>
            </div>

            <div
              v-else
              ref="patientBox"
              class="patient-box"
            >
              <lila-patient-card-summary :patient="data.selectedPatient" />

              <div class="menu-patient-card">
                <ul>
                  <li
                    :class="
                      $route.name == 'myPatientMedicalRecord' ? 'active' : ''
                    "
                  >
                    <router-link
                      :to="{
                        name: 'myPatientMedicalRecord',
                        params: {
                          id: data.selectedPatient.Id
                        }
                      }"
                    >
                      Ficha
                    </router-link>
                  </li>
                  <li
                    :class="
                      $route.name == 'myPatientHistoryRecords' ? 'active' : ''
                    "
                  >
                    <router-link
                      :to="{
                        name: 'myPatientHistoryRecords',
                        params: {
                          id: data.selectedPatient.Id
                        }
                      }"
                    >
                      Registros
                    </router-link>
                  </li>
                  <li
                    v-show="userHasPermission(2)"
                    :class="
                      $route.name == 'mypatientPrescriptions' ? 'active' : ''
                    "
                  >
                    <router-link
                      :to="{
                        name: 'mypatientPrescriptions',
                        params: {
                          id: data.selectedPatient.Id
                        }
                      }"
                    >
                      Receita Médica
                    </router-link>
                  </li>
                  <li
                    :class="
                      $route.name == 'myPatientClinicalEvolution'
                        ? 'active'
                        : ''
                    "
                  >
                    <router-link
                      :to="{
                        name: 'myPatientClinicalEvolution',
                        params: {
                          id: data.selectedPatient.Id
                        }
                      }"
                    >
                      Evolução Clínica
                    </router-link>
                  </li>

                  <li :class="$route.name == 'myPatientChat' ? 'active' : ''">
                    <router-link
                      :to="{
                        name: 'myPatientChat',
                        params: {
                          id: data.selectedPatient.Id
                        }
                      }"
                    >
                      Conversa
                    </router-link>
                  </li>

                  <!-- POC Cuidados Paliativos: role 1 simula a equipe assistencial -->
                  <li
                    v-if="isAssistencialRole"
                    :class="
                      $route.name == 'myPatientMatrixSupport' ? 'active' : ''
                    "
                  >
                    <router-link
                      :to="{
                        name: 'myPatientMatrixSupport',
                        params: { id: data.selectedPatient.Id }
                      }"
                    >
                      Solicitar apoio
                    </router-link>
                  </li>

                  <!-- POC Cuidados Paliativos: role 2 simula a equipe matricial -->
                  <li
                    v-if="isMatrixRole"
                    :class="
                      $route.name == 'myPatientMatrixRequest' ? 'active' : ''
                    "
                  >
                    <router-link
                      :to="{
                        name: 'myPatientMatrixRequest',
                        params: { id: data.selectedPatient.Id }
                      }"
                    >
                      Pedido de apoio
                    </router-link>
                  </li>

                  <li
                    v-show="userHasPermission(8)"
                    :class="$route.name == 'myPatientBarriers' ? 'active' : ''"
                  >
                    <router-link
                      :to="{
                        name: 'myPatientBarriers',
                        params: { id: data.selectedPatient.Id }
                      }"
                    >
                      Barreiras
                    </router-link>
                  </li>
                  <li
                    v-if="hasAccessToActionFeature()"
                    :class="$route.name == 'myPatientActions' ? 'active' : ''"
                  >
                    <router-link
                      :to="{
                        name: 'myPatientActions',
                        params: { id: data.selectedPatient.Id }
                      }"
                    >
                      Ações
                    </router-link>
                  </li>

                  <li
                    :class="
                      $route.name == 'myPatientChatHistory' ? 'active' : ''
                    "
                  >
                    <router-link
                      :to="{
                        name: 'myPatientChatHistory',
                        params: {
                          id: data.selectedPatient.Id
                        }
                      }"
                    >
                      Chamados Encerrados
                    </router-link>
                  </li>

                  <li
                    :class="
                      $route.name == 'myPatientAttachments' ? 'active' : ''
                    "
                  >
                    <router-link
                      :to="{
                        name: 'myPatientAttachments',
                        params: {
                          id: data.selectedPatient.Id
                        }
                      }"
                    >
                      Anexos
                    </router-link>
                  </li>

                  <li
                    v-if="userHasPermission(13)"
                    :class="
                      $route.name == 'myPatientTeleconsultas' ? 'active' : ''
                    "
                  >
                    <router-link
                      :to="{
                        name: 'myPatientTeleconsultas',
                        params: {
                          id: data.selectedPatient.Id
                        }
                      }"
                    >
                      Teleconsultas
                    </router-link>
                  </li>

                  <li
                    v-if="canManage"
                    :class="
                      $route.name == 'myPatientManagement' ? 'active' : ''
                    "
                  >
                    <router-link
                      :to="{
                        name: 'myPatientManagement',
                        params: {
                          id: data.selectedPatient.Id
                        }
                      }"
                    >
                      Gestão
                    </router-link>
                  </li>
                </ul>
              </div>

              <router-view
                :closed-ticket-id="closedTicketId"
                :new-message-for-patient="newMessageForPatient"
                :selected-patient="data.selectedPatient"
                @update-patient="updatePatient"
                @update-patient-card-summary="updatePatientCardSummary"
                @update-patient-team="updatePatientTeam"
              />
            </div>
          </div>
        </div>

        <lila-cid-modal
          v-show="activeArea === 'atendimento'"
          :modal-active="cidModalActive"
          @custom-click-event="selectCid"
        />

        <div
          v-if="canManage && activeArea === 'gestao'"
          class="patients-management-area"
        >
          <patients-management-card
            @custom-edit-event="editPatientFromManagement"
          />
        </div>
      </div>
    </template>
  </lila-default-template>
</template>

<script lang="ts">
import { defineComponent, ref, provide, watch } from "vue";
import DefaultTemplate from "@components/template/DefaultTemplate.vue";
import Input from "@components/shared/fields/Input.vue";
import Select from "@components/shared/fields/Select.vue";
import Button from "@components/shared/button/Button.vue";
import Radio from "@components/shared/fields/Radio.vue";
import SvgIcon from "@components/shared/images/SvgIcon.vue";
import Message from "@components/shared/message/Message.vue";
import PatientCard from "@components/shared/lila/PatientCard.vue";
import PatientCardSummary from "@components/shared/lila/PatientCardSummary.vue";
import CidModal from "@components/shared/lila/CidModal.vue";
import PatientAreaTabs from "@/views/patients/PatientAreaTabs.vue";
import PatientsManagementCard from "@/views/management/PatientsManagement.vue";
import {
  Patient,
  CIDType,
  PatientCID,
  Alert,
  FrontendPatient
} from "@/models";
import {
  PerformanceStatus,
  performanceStatusList
} from "@/enums/PerformanceStatus";
import decodeToken from "@/js/decodeToken";
import { utilities } from "@/plugins/UtilitiesV2";
import { HubConnection } from "@microsoft/signalr";
import { AlertMessage, AlertType } from "@/enums/Index";

require("@microsoft/signalr");

export default defineComponent({
  components: {
    "lila-input": Input,
    "lila-select": Select,
    "lila-button": Button,
    "lila-radio": Radio,
    "lila-svgIcon": SvgIcon,
    "lila-patient-card": PatientCard,
    "lila-patient-card-summary": PatientCardSummary,
    "lila-message": Message,
    "lila-cid-modal": CidModal,
    "lila-default-template": DefaultTemplate,
    "patient-area-tabs": PatientAreaTabs,
    "patients-management-card": PatientsManagementCard
  },
  setup() {
    const alert = ref<Alert>({
      message: "",
      type: AlertType.SUCCESS,
      show: false
    });

    provide("alert-message", alert);

    return {
      alert
    };
  },
  data() {
    return {
      activeArea: "atendimento" as "atendimento" | "gestao",
      userId: null as number | null,
      data: {
        selectedPatient: null as FrontendPatient | null,
        patientList: [] as FrontendPatient[]
      },
      orderByVisible: false,
      filterByVisible: false,
      orderByList: [
        { _id: 1, name: "Nome do Paciente" },
        { _id: 2, name: "Data da última mensagem" }
      ],
      performanceStatusList: require("@assets/options/performanceStatus.json")
        .options,
      estadioList: require("@assets/options/estadio.json").options,
      search: {
        byNameOrRegisterNumber: "",
        byCid: "",
        byEstadio: "",
        cidCode: "",
        activeNameOrRegisterNumber: false,
        activeCid: false,
        activeEstadio: false,
        activateClearSearchBtn: false
      },
      loadingSignalR: false,
      ticketSignalR: {
        active: false,
        connection: null as any,
        timeout: false,
        retryCount: 0
      },
      signalRTimeout: 0,
      signalRMaxRetry: 3,
      newMessageForPatient: {} as any,
      closedTicketId: null as number | null,
      cidModalActive: false,
      pageName: this.$route.name,
      loading: false,
      loadingContent: false,
      loadingInfinityScroll: false,
      firstLoading: true,
      patientColumnHeight: 0,
      patientColumnHeightInterval: null as any,
      pagination: {
        current: 0,
        totalPages: 0,
        perPage: 10,
        lastPage: false
      }
    };
  },

  computed: {
    canManage(): boolean {
      return (this as any).$Utilities.hasManagementAccess(this);
    },
    // POC Cuidados Paliativos: role 1 (UnitAdmin) simula a equipe assistencial.
    isAssistencialRole(): boolean {
      return (this as any).$Utilities.isPalliativeAssistencialTeam(this);
    },
    // POC Cuidados Paliativos: role 2 (InstitutionAdmin) simula a equipe matricial.
    isMatrixRole(): boolean {
      return (this as any).$Utilities.isPalliativeMatrixTeam(this);
    }
  },

  watch: {
    $route(to) {
      this.pageName = to.name;
      if (this.pageName === "myPatients") this.data.selectedPatient = null;
    }
  },

  created() {
    const session = this.$Session.get(this.$userSessionName);
    this.userId = session.professional.Id;

    if (this.$route.query.customMessageType) {
      const data = {
        customMessage: {
          type: this.$route.query.customMessageType,
          message: this.$route.query.customMessage
        }
      };
      utilities.showResultMessage(data, this.alert);
    } else {
      utilities.showResultMessage(this.$route.query, this.alert);
    }

    this.getPatientList();
    this.startTicketSignalR();
  },

  mounted() {
    this.controlSidebarHeight();

    this.setupIntersectionObserver();
  },

  beforeUnmount() {
    clearInterval(this.patientColumnHeightInterval);
    this.closeSignalRConnections();
  },

  methods: {
    setupIntersectionObserver() {
      const options = {
        root: this.$refs.conversationList as HTMLElement | null, 
        rootMargin: "0px",
        threshold: 0.1 
      };
      const observer = new IntersectionObserver(
        this.handleIntersection,
        options
      );

      const sentinel = this.$refs.scrollSentinel as HTMLElement;

      if (sentinel) {
        observer.observe(sentinel);
      }
    },

    handleIntersection(entries: IntersectionObserverEntry[]) {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !this.loadingInfinityScroll) {
          this.getPatientList(this.pagination.current + 1);
        }
      });
    },

    mapToFrontendPatient(item: any): FrontendPatient {
      return {
        Id: item.Id,
        Name: item.Name,
        SocialName: "",
        RegisterNumber: item.RegisterNumber || item.registerNumber || "",
        profilePicture: item.Photo
          ? item.Photo
          : utilities.getDefaultProfilePicture(item.Gender),
        displayCid: utilities.getPatientCid(item) || "",
        Gender: item.Gender,
        BirthDate: item.BirthDate,
        Diagnostic: item.Diagnostic,
        Status: item.Status,
        CIDs: item.CIDs,
        painLevel: "",
        doctor: item.Doctor?.Name || "",
        imgLoaded: false,
        ticketId: item.OpenTicket ? item.OpenTicket.Id : null,
        doctorPriority: item.OpenTicket ? item.OpenTicket.DoctorPriority : "",
        Race: item.Race,
        Education: item.Education,
        Employment: item.Employment,
        MaritalStatus: item.MaritalStatus,
        JourneyStage: item.JourneyStage,
        SymptomStartPeriod: item.SymptomStartPeriod,
        selectedRace: "",
        selectedMaritalStatus: "",
        selectedEmployment: "",
        selectedEducation: "",
        selectedSymptomStartPeriod: "",
        selectedJourneyStage: "",
        CNS: "",
        Observations: "",
        CompanionType: item.CompanionType,
        selectedCompanionType: ""
      };
    },

    async getPatientList(page = 1, searchType = "", localLoading = false) {
      if (this.isAlreadyLoading() || this.pagination.lastPage) {
        return;
      }

      const apiEndpoint = this.buildApiEndpoint(page, searchType);

      if (!this.firstLoading) {
        //this.alert.show = false;
      }

      this.prepareForLoading(searchType, localLoading, page);

      try {
        const response = await this.fetchPatientData(apiEndpoint);

        this.firstLoading = false;

        this.updatePagination(response.data.Pagination);

        this.updatePatientList(response.data.Data);

        await this.handleSelectedPatientFromRoute();

        this.handleEmptyPatientList();
      } catch (error) {
        this.handleRequestError(error);
      } finally {
        this.resetLoadingStates();
      }
    },

    isAlreadyLoading() {
      return this.loadingContent || this.loadingInfinityScroll;
    },

    buildApiEndpoint(page: number, searchType: string): string {
      const paginationParams = `?page=${page}&limit=${this.pagination.perPage}`;
      const searchParams = this.createParameters();

      return searchParams
        ? `/api/patient/search${paginationParams}${searchParams}`
        : `/api/patient${paginationParams}`;
    },

    prepareForLoading(searchType: string, localLoading: boolean, page: number) {
      if (searchType !== "" || localLoading || page > 1) {
        if (searchType !== "") {
          this.data.patientList = [];
        }
        this.loadingInfinityScroll = true;
        this.scrollPatientListToBottom();
      } else {
        this.loadingContent = true;
      }
    },

    async fetchPatientData(apiEndpoint: string) {
      return await this.$axios.get(apiEndpoint, {
        headers: {
          Authorization: `Bearer ${
            this.$Session.get(this.$userSessionName).token.Value
          }`
        }
      });
    },

    updatePagination(paginationData: any) {
      if (paginationData.TotalPage === paginationData.CurrentPage) {
        this.pagination.lastPage = true;
      }
      this.pagination.current = paginationData.CurrentPage;
      this.pagination.totalPages = paginationData.TotalPage;
    },

    updatePatientList(patientData: any[]) {
      this.data.patientList = [
        ...(this.data.patientList || []),
        ...patientData
          .filter((item) => item != null)
          .map(this.mapToFrontendPatient)
      ];
    },

    async handleSelectedPatientFromRoute() {
      if (this.$route.params.id) {
        const patientId = Array.isArray(this.$route.params.id)
          ? parseInt(this.$route.params.id[0], 10)
          : parseInt(this.$route.params.id, 10);

        if (!isNaN(patientId)) {
          await this.getSelectedPatient(patientId);
        } else {
          console.error("Invalid patient ID:", this.$route.params.id);
          this.$router.push({ name: "myPatients" });
        }

        if (!this.data.selectedPatient) {
          this.$router.push({ name: "myPatients" });
        }
      }
    },

    handleEmptyPatientList() {
      if (this.data.patientList.length === 0) {
        this.alert.type = AlertType.WARNING;
        this.alert.message = AlertMessage.EMPTY_LIST;
        utilities.controlAlert(null, this.alert);
      }
    },

    handleRequestError(error: any) {
      if (utilities.isAxiosError(error) && error.response) {
        utilities.verifyToken(error.response.status);
        this.alert.type = AlertType.DANGER;
        this.alert.message = AlertMessage.ERROR;
        utilities.controlAlert(error.response.data, this.alert);
      } else {
        console.error("Unexpected error:", error);
        this.alert.type = AlertType.DANGER;
        this.alert.message = AlertMessage.ERROR;
        utilities.controlAlert(null, this.alert);
      }
    },

    resetLoadingStates() {
      this.loadingContent = false;
      this.loadingInfinityScroll = false;
    },

    async getPatientPain(patientId: number) {
      try {
        const response = await this.$axios.get(
          `/api/clinicalevolution/pain/patient/${patientId}`,
          {
            headers: {
              Authorization: `Bearer ${
                this.$Session.get(this.$userSessionName).token.Value
              }`
            }
          }
        );

        if (response.data && this.data.selectedPatient) {
          this.data.selectedPatient.painLevel = `EVA ${response.data.Evolutions[0].Intensity}`;
        }
      } catch (error) {
        console.error("Error fetching patient pain:", error);
        if (utilities.isAxiosError(error) && error.response) {
          utilities.verifyToken(error.response.status);
        } else {
          console.error("Unexpected error:", error);
        }
      } finally {
        this.loadingContent = false;
      }
    },
    scrollPatientListToBottom() {
      setTimeout(() => {
        const conversationList = this.$refs
          .conversationList as HTMLElement | null;
        if (conversationList) {
          conversationList.scrollTo(0, conversationList.scrollHeight);
        }
      }, 50);
    },
    openOptions(option: string) {
      if (option === "orderBy") {
        this.orderByVisible = !this.orderByVisible;
        this.filterByVisible = false;
      } else if (option === "filterBy") {
        this.filterByVisible = !this.filterByVisible;
        this.orderByVisible = false;
      }
    },
    selectPatient(patient: FrontendPatient) {
      this.data.selectedPatient = { ...patient };
      this.getPatientPain(patient.Id);
    },

    async editPatientFromManagement(patientId: number) {
      this.activeArea = "atendimento";
      await this.getSelectedPatient(Number(patientId));
      this.$router.push({
        name: "myPatientMedicalRecord",
        params: { id: String(patientId) }
      });
    },

    async getPatientById(patientId: number) {
      try {
        const response = await this.$axios.get(`/api/patient/${patientId}`, {
          headers: {
            Authorization: `Bearer ${
              this.$Session.get(this.$userSessionName).token.Value
            }`
          }
        });

        const patient = response.data;

        if (patient) {
          this.selectPatient(this.mapToFrontendPatient(patient)); 
        } else {
          console.warn("Patient not found, resetting to patient list");
          this.$router.push({ name: "myPatients" });
        }
      } catch (error) {
        console.error("Error fetching patient by ID:", error);
        this.$router.push({ name: "myPatients" });
      }
    },
    async getSelectedPatient(patientId: number) {
      const patient = this.data.patientList.find(
        (item) => item.Id === patientId
      );

      if (patient) {
        this.selectPatient(patient);
      } else {
        try {
          await this.getPatientById(patientId); 
        } catch (error) {
          console.error("Error fetching patient by ID:", error);
        }
      }
    },

    updatePatientTeam(payload: { teamId: number; teamName: string }) {
      const name = payload && payload.teamName ? payload.teamName : "";
      if (this.data.selectedPatient) {
        this.data.selectedPatient.doctor = name;
      }
      const id = this.data.selectedPatient?.Id;
      const row = this.data.patientList.find((p: FrontendPatient) => p.Id === id);
      if (row) row.doctor = name;
    },

    updatePatient(patient: FrontendPatient) {
      for (let index = 0; index < this.data.patientList.length; index++) {
        if (this.data.patientList[index].Id === this.data.selectedPatient?.Id) {
          // Update relevant fields in the patient list entry
          this.data.patientList[index].Name = patient.Name;
          this.data.patientList[index].displayCid =
            utilities.getSelectedPatientCid(patient);
          this.data.patientList[index].Gender = patient.Gender;
          this.data.patientList[index].BirthDate = patient.BirthDate
            ? utilities.formatDate(
                patient.BirthDate,
                "DD/MM/YYYY",
                "MM/DD/YYYY"
              )
            : "";
          this.data.patientList[index].Diagnostic = patient.Diagnostic;

          break;
        }
      }
    },

    updatePatientCardSummary(patient: FrontendPatient) {
      // Ensure the selected patient exists
      if (!this.data.selectedPatient) return;

      // Update the selectedPatient with the new patient data
      this.data.selectedPatient.Name = patient.Name;
      this.data.selectedPatient.displayCid =
        utilities.getSelectedPatientCid(patient); // Update displayCid with the processed CID
      this.data.selectedPatient.Gender = patient.Gender;
      this.data.selectedPatient.BirthDate = patient.BirthDate
        ? utilities.formatDate(patient.BirthDate, "DD/MM/YYYY", "MM/DD/YYYY")
        : "";
      this.data.selectedPatient.Diagnostic = patient.Diagnostic;

      if (patient.painLevel) {
        this.data.selectedPatient.painLevel = patient.painLevel;
      }
    },
    openCidModal() {
      this.cidModalActive = !this.cidModalActive;
    },
    selectCid(cid: any) {
      this.search.byCid = cid.CIDTypeId;
      this.search.cidCode = cid.CIDCode;

      this.filterBy("byCid");
    },

    createParameters() {
      let params = "";

      if (this.search.activeNameOrRegisterNumber)
        params += `&queryParameter=${this.search.byNameOrRegisterNumber}`;
      if (this.search.activeCid) params += `&cidId=${this.search.byCid}`;
      if (this.search.activeEstadio)
        params += `&estadio=${this.search.byEstadio}`;

      return params;
    },

    filterBy(filterBy: string) {
      switch (filterBy) {
        case "byNameOrRegisterNumber":
          this.search.activeNameOrRegisterNumber = true;
          this.search.activateClearSearchBtn = true;
          break;
        case "byCid":
          this.search.activeCid = true;
          break;
        case "byEstadio":
          this.search.activeEstadio = !!this.search.byEstadio;
          break;
      }

      this.clearPagination();
      this.getPatientList(1, filterBy);
    },

    clearFilterBy(filterBy: string) {
      switch (filterBy) {
        case "byNameOrRegisterNumber":
          this.clearSearchByNameFields();
          break;
        case "byCidEstadio":
          this.clearFilterByFields();
          break;
      }

      this.getPatientList(1, "", true);
    },

    clearSearchByNameFields() {
      this.search.byNameOrRegisterNumber = "";
      this.search.activeNameOrRegisterNumber = false;
      this.search.activateClearSearchBtn = false;

      this.clearPagination();
    },

    clearFilterByFields() {
      this.search.byCid = "";
      this.search.cidCode = "";
      this.search.byEstadio = "";
      this.search.activeCid = false;
      this.search.activeEstadio = false;
      this.clearPagination();
    },

    clearPagination() {
      this.pagination.current = 0;
      this.pagination.totalPages = 0;
      this.pagination.lastPage = false;
    },

    checkEndOfPage() {
      setTimeout(() => {
        const conversationList = this.$refs.conversationList as HTMLElement;

        if (conversationList) {
          const { scrollTop, clientHeight, scrollHeight } = conversationList;

          if (scrollTop + clientHeight + 250 >= scrollHeight) {
            this.getPatientList(this.pagination.current + 1);
          }
        }
      }, 1000);
    },
    controlSidebarHeight() {
      this.patientColumnHeightInterval = setInterval(() => {
        const patientBox = this.$refs.patientBox as HTMLElement | null;
        const conversationList = this.$refs
          .conversationList as HTMLElement | null;

        if (
          patientBox &&
          conversationList &&
          this.patientColumnHeight !== patientBox.offsetHeight
        ) {
          this.patientColumnHeight = patientBox.offsetHeight;
          conversationList.style.height = `${this.patientColumnHeight - 50}px`;
        }
      }, 500);
    },
    userHasPermission(feature: number) {
      const sessionToken = this.$Session.get(this.$userSessionName)?.token
        ?.Value;

      const decodedToken = utilities.decodeToken(sessionToken);

      return decodedToken && decodedToken.FeaturesId?.includes(feature);
    },

    hasAccessToActionFeature() {
      return utilities.hasAccessToFeature(7);
    },

    startTicketSignalR() {
      try {
        if (this.ticketSignalR.connection != null) return true;

        this.ticketSignalR.connection = this.$SignalRConnector.startSignalR(
          "messageprofessionalhub",
          (connection: HubConnection) => {
            this.startTicketSignalRListeners(connection);
          },
          this.signalRTimeout,
          String(this.userId),
          "patientList"
        );
      } catch (error) {
        console.log("Erro na comunicação com o SignalR:", error);

        if (this.ticketSignalR.retryCount < this.signalRMaxRetry) {
          ++this.ticketSignalR.retryCount;

          this.startTicketSignalR();
        }
      }
    },

    async startTicketSignalRListeners(connection: HubConnection) {
      try {
        connection.on("PatientMessage", (res) => {
          this.loadingSignalR = true;

          this.newMessageForPatient = {
            patientId: res.fromId,
            ticketId: res.ticketId
          };
        });

        connection.on("ChatClosed", (res) => {
          this.loadingSignalR = true;

          this.closedTicketId = res.id;
          this.loadingSignalR = false;
        });
      } catch (error) {
        console.error("Erro ao iniciar os listeners do SignalR:", error);
      }
    },

    closeSignalRConnections() {
      if (typeof this.ticketSignalR.timeout === "number") {
        clearTimeout(this.ticketSignalR.timeout);
      }

      if (this.ticketSignalR.connection) {
        this.$SignalRConnector.stopSignalR(
          this.ticketSignalR.connection,
          "patientList"
        );
      }

      this.ticketSignalR.active = false;
    }
  }
});
</script>

<style lang="scss">
@import "~@assets/css/components/patientTickets.css";
@import "~@assets/css/views/patients.css";
@import "~@assets/css/views/patientTickets.css";

.patient-list > h1.title {
  margin-top: 4px;
}

.patient-list .columns {
  display: flex;
}

.patient-list .patient-sidebar {
  flex: 1;
  max-width: 400px;
}

.patient-list .patient-column {
  flex: 2;
  min-width: 300px;
}
</style>
